import { timeRangeZodSchema } from "@@/shared/date-time/time-range";
import { payoutTargetZodSchema } from "@@/shared/financials/payout-targets/payout-target";
import { metaContentZodSchema } from "@@/shared/meta-content/meta-content";
import { providerSlugZodSchema } from "@@/shared/providers/provider";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import type { Except } from "type-fest";
import { z } from "zod";
import { hardCodedFeeIdZodEnum } from "./settlements/hard-coded-fees";

const createSettlementNote_providerDefaultsZodObject = z.object({
    _type: z.literal("CREATE_SETTLEMENT_NOTE__PROVIDER_DEFAULTS"),
    providerId: providerIdZodSchema,
    slug: providerSlugZodSchema,
    meta: metaContentZodSchema,
    defaultHardCodedFeeIds: z.array(hardCodedFeeIdZodEnum),
    lastUsedHardCodedFeeIds: z.array(hardCodedFeeIdZodEnum),
    lastUsedPayoutTarget: payoutTargetZodSchema.optional(),
    lastTimeRange: timeRangeZodSchema.optional(),
});
type CreateSettlementNote_ProviderDefaults = z.infer<
    typeof createSettlementNote_providerDefaultsZodObject
>;

type FactoryParams = Except<CreateSettlementNote_ProviderDefaults, "_type">;

const createSettlementNote_providerDefaultsFactory = (
    params: FactoryParams,
): CreateSettlementNote_ProviderDefaults => {
    return {
        ...params,
        _type: "CREATE_SETTLEMENT_NOTE__PROVIDER_DEFAULTS",
    };
};

export {
    createSettlementNote_providerDefaultsFactory,
    createSettlementNote_providerDefaultsZodObject,
};
export type { CreateSettlementNote_ProviderDefaults };
